import { render, staticRenderFns } from "./EconomicalStatusesFormInput.vue?vue&type=template&id=1258ab01&scoped=true&"
import script from "./EconomicalStatusesFormInput.vue?vue&type=script&lang=js&"
export * from "./EconomicalStatusesFormInput.vue?vue&type=script&lang=js&"
import style0 from "./EconomicalStatusesFormInput.vue?vue&type=style&index=0&id=1258ab01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1258ab01",
  null
  
)

/* custom blocks */
import block0 from "./EconomicalStatusesFormInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports